import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'name', label: 'Customer' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'quotations_count', label: 'Quotations', align: 'right' },
  { key: 'invoices_count', label: 'Invoices', align: 'right' },
  { key: 'notes', label: 'Notes' },
];

export function CustomerRegisterReport() {
  return (
    <ReportView
      title="Customer Register"
      description="Full customer listing with contact details and quotation/invoice counts."
      endpoint="/reports/revenue/customer-register"
      columns={COLUMNS}
    />
  );
}
